// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"hN-z","upvoteIcon":"iN-z","downvoteIcon":"jN-z","feedbackIcon":"kN-z"};